import { makeStyles } from '@map/theme';
import Button from '@ui/Button';
import { ReactElement, type ReactNode } from 'react';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    '&:hover': {
      color: palette.primary[500],
      backgroundColor: palette.primary[100],
      borderColor: palette.primary[500],
    },
    svg: {
      height: '24px',
      width: '24px',
    },
  },
}));

type Props = {
  label: ReactNode;
  icon?: ReactElement;
  onClick: () => void;
};
const SocialPillButton = ({ icon, onClick, label }: Props) => {
  const { classes } = useStyles();
  return (
    <Button
      fullWidth={true}
      size="medium"
      variant="secondary"
      startIcon={icon}
      onClick={onClick}
      className={classes.root}
    >
      {label}
    </Button>
  );
};

export default SocialPillButton;
